/**
 * 說明 : 驗證資料與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import {createAsyncThunk} from '@reduxjs/toolkit';

// ----- import from Base API -----
import BaseAPI from './BaseAPI';

/** @type {string} */
export const TOKEN_SAVING_KEY = 'token';

export const getTokenFromStorage = () => (
  localStorage.getItem(TOKEN_SAVING_KEY) ||
  sessionStorage.getItem(TOKEN_SAVING_KEY) ||
  ''
);

export const clearToken = () => {
  localStorage.removeItem(TOKEN_SAVING_KEY);
  sessionStorage.removeItem(TOKEN_SAVING_KEY);
};

export const login = createAsyncThunk(
  'auth/login',
  async ({account, password, persist}, {rejectWithValue}) => {
    try {
      const data = await BaseAPI.post('/login', {account, password});
      // toast.success("Login Successfully");
      if (data.result) {
        const token = data.result.token;
        if (token) {
          const savingLocation = persist ? localStorage : sessionStorage;
          savingLocation.setItem(TOKEN_SAVING_KEY, token);
        }
      }
      return data;
    } catch (err) {
      console.error('login error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const authenticate = createAsyncThunk(
  'auth/authenticate',
  async (_, {getState, rejectWithValue}) => {
    try {
      let token = getState().auth.token;
      if (token === null || token === undefined || token === '') {
        token = getTokenFromStorage();
      }
      const data = await BaseAPI.getWithAuth('/login/auth', null, token);
      return data;
    } catch (err) {
      console.error('login error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.deleteWithAuth('/logout', null, token);
      if (token) {
        clearToken(); // Remove token from cookie on logout
      }
      return data;
    } catch (err) {
      console.error('logout error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
